import Button from "./Button";
import "../Info.css"

const VSe = ()=>{
    return(
        <div className="infoalbum">
  <h1 className="title">Versus: Villains </h1>
  <div className="infoal">
    <div className="infotext">
      <Button/>
    <p>- PObs = from <span className="colorunoa">8usd</span> <span className="colordosa"> 10 usd</span></p>
            <p className="ver">LIMITED (ver. c)</p>
            <p>- Limited photobook (cd+pb) = <span className="colorunoa">9,5usd</span> <span className="colordosa"> 8 usd</span></p>
            <p>-Limited photocard = <span className="colorunoa">4usd</span> <span className="colordosa"> 10 usd</span></p>
            <p>- OOTD card = <span className="colorunoa">2,5usd</span> <span className="colordosa"> 2,5 usd</span></p>
            <p>- Postcards(Set ot7) = <span className="colorunoa">1usd c/u</span> <span className="colordosa"> 5 usd set</span></p>
            <p>- POB poster(double sided)= <span className="colorunoa">1,5usd</span> <span className="colordosa"> 1 usd</span></p>
            <p>- Stickers =  <span className="colorunoa">0,8usd</span> <span className="colordosa"> 0,5 usd</span></p>
            <p className="ver">NORMAL (ver. U - R - S - E)</p>
            <p>- Photobook (cd+pb) = <span className="colorunoa">8usd</span> <span className="colordosa"> 10 usd</span></p>
            <p>- Photocard = <span className="colorunoa">4,2usd</span> <span className="colordosa"> 2 usd</span></p>
            <p>- Stickers = <span className="colorunoa">0,8usd</span> <span className="colordosa"> 0,5 usd</span></p>
            <p>- Postcard =<span className="colorunoa">1,5usd</span> <span className="colordosa"> 2 usd</span></p>
            <p>- POB poster ( double sided )= <span className="colorunoa">1,5usd</span> <span className="colordosa"> 1 usd</span></p>
            <p className="ver">POCA</p>
            <p>- Pacakge + standee= <span className="colorunoa"> 2 usd</span><span className="colordosa"> 2usd</span> </p>
            <p>- Photocard = <span className="colorunoa">3usd</span> <span className="colordosa"> 4 usd</span></p>
            <p>- QR Photocard =<span className="colorunoa">3,2usd</span> <span className="colordosa"> 4 usd</span></p>
            <p>- Stickers =  <span className="colorunoa">1usd</span> <span className="colordosa"> 0,5 usd</span></p>
    </div>
    <div className="infoalimg ">
    <img src="https://pbs.twimg.com/media/GAoJCUEW8AAFozf?format=jpg&name=4096x4096" alt="Album Cover"  style={{ boxShadow: "3.5px 3.5px 0px rgb(140, 12, 12" }} />
    <img src="https://pbs.twimg.com/media/GAoJEiWWUAALvXe?format=jpg&name=4096x4096" alt="Album Cover"  style={{ boxShadow: "3.5px 3.5px 0px rgb(140, 12, 12" }}/>
    </div>
  </div>
</div>

  )
}

export default VSe;